(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxWizardManager', {
		bindings: {
			finishButtonText: '@?',
			successSubmitMessage: '@?',
			reloadOnFinish: '@?',
			resetActionsCache: '@?',
			resetNavigationCache: '@?',
			resetEnumCache: '@?',
			resetWidgetCache: '@?',
			resetCacheForWidgets: '=?',
			resetSchemaLocalCache: '@?',
			hideFinishButton: '=?',
			hideDetails: '=?',
			pagesToSkip: '=?',
			currentPage: '=?',
			disableNextButton: '=?',
			disableSuccessMessage: '@?',
			wizard: '=',
			openFullScreen: '@?',
			// Post action contracts
			paType: '@type',
			paActive: '@active',

			paAction: '@?action',
			paActionContext: '=?actionContext',

			paEntityType: '@?entityType',
			paObjectId: '@?objectId',
			paFullScreen: '@?fullScreen',

			// End of post action contracts
		},
		controller: MxWizardManager,
		controllerAs: 'vm',
	});

	MxWizardManager.$inject = ['$scope', '$timeout', 'mx.SolutionBuilderAgent.WizardService', 'mx.SolutionBuilderAgent.MixedActionHelper', 'mx.shell.SideLayout'];

	function MxWizardManager($scope, $timeout, wizardService, mixedActionHelper, sideLayoutService) {
		var vm = this;
		var paActive = false;
		var paObjectId = '';

		vm.$onInit = function () {
			vm.managerId = vm.wizard.registerWizardManager(vm);

			vm.postAction = {
				run: function () {},
			};
			var finishButton = vm.wizard.allWizardPages[vm.wizard.allWizardPages.length - 1].buttons.finish;
			var oldCallback = finishButton.callback;

			finishButton.callback = function (_result) {
				finishButton.successSubmitMessage = vm.disableSuccessMessage === 'true' ? false : vm.successSubmitMessage;

				return oldCallback(_result).then(function (result) {
					$timeout(function () {
						wizardService.processFinishEvents(
							vm.resetActionsCache === 'true',
							vm.resetNavigationCache === 'true',
							vm.resetEnumCache === 'true',
							vm.resetWidgetCache === 'true',
							typeof vm.resetCacheForWidgets === 'string' ? vm.resetCacheForWidgets.split(',') : vm.resetCacheForWidgets,
							vm.resetSchemaLocalCache,
							vm.reloadOnFinish === 'true',
							vm.postAction
						);
					});
					return result;
				});
			};
			paActive = vm.paActive === 'true';
			Object.defineProperty(vm, 'paActive', {
				get: function () {
					return paActive;
				},
				set: function (value) {
					paActive = value === 'true';

					vm.postAction.isActive = paActive;
					vm.postAction.run = mixedActionHelper.init(getPostActionSettings());
					vm.wizard.allWizardPages.forEach(function (page) {
						page.buttons.cancel.isVisible = vm.paActive !== undefined;
					});
				},
			});
			paObjectId = vm.paObjectId;
			Object.defineProperty(vm, 'paObjectId', {
				get: function () {
					return paObjectId;
				},
				set: function (value) {
					paObjectId = value;
					vm.postAction.run = mixedActionHelper.init(getPostActionSettings());
				},
			});

			var openFullScreen = (vm.openFullScreen || '').toLowerCase() === 'true';
			if (openFullScreen) {
				sideLayoutService.switchFullScreenMode(openFullScreen);
			}

			$scope.$watch('vm.finishButtonText', function () {
				if (vm.finishButtonText) {
					updateFinishButtonTitles(vm.wizard.pages, vm.finishButtonText);
					updateFinishButtonTitles(vm.wizard.allWizardPages, vm.finishButtonText);
				}
			});

			$scope.$watch('vm.hideFinishButton', function (newValue) {
				vm.wizard.hideFinishButton = newValue;
			});

			$scope.$watch('vm.hideDetails', function () {
				var page = vm.wizard.pages[0];

				if (page && page.dataModel) {
					page.dataModel.Context.__hideDetails = vm.hideDetails;
				}
			});

			$scope.$watch('vm.pagesToSkip', onChangeSkippedPages);

			$scope.$watch('vm.paEntityType', function () {
				vm.postAction.run = mixedActionHelper.init(getPostActionSettings());
			});

			$scope.$watch(
				function (scope) {
					return scope.vm.wizard.allWizardPages;
				},
				function () {
					onChangeSkippedPages(vm.pagesToSkip);
				}
			);

			$scope.$watch(
				function (scope) {
					return scope.vm.wizard.currentPage.id;
				},
				function () {
					vm.currentPage = vm.wizard.currentPage.key;
				}
			);

			$scope.$watch('vm.disableNextButton', function () {
				if (vm.wizard && vm.wizard.currentPage && vm.wizard.currentPage.buttons.next) {
					vm.wizard.currentPage.buttons.next.isDisabled = Boolean(vm.disableNextButton);
				}
			});
		};

		return vm;

		function getPostActionSettings() {
			return {
				type: vm.paType,
				action: vm.paAction,
				actionContext: vm.paActionContext,
				entityType: vm.paEntityType,
				objectId: vm.paObjectId,
				fullScreen: vm.paFullScreen === 'true',
				// TODO: extend with navigation, landing, external link, etc
			};
		}

		function updateFinishButtonTitles(pages, finishButtonTitle) {
			pages.forEach(function (page) {
				page.buttons.finish.title = finishButtonTitle;
			});
		}

		function onChangeSkippedPages(pagesToSkip) {
			vm.wizard.skipPagesByManager(vm.managerId, pagesToSkip);
		}
	}
})();
